import PropTypes from 'prop-types'
import React from 'react'
import { withRouter } from '@/checkout-instore-legacy/utils/withRouter'
import Swiper from 'react-id-swiper'
import classNames from 'classnames'
import Loader from '@/checkout-instore-legacy/components/Commons/Loader'
import Footer from '@/checkout-instore-legacy/components/Commons/Footer'
import * as CustomEvent from '@/checkout-instore-legacy/utils/CustomEvent'
import { getInstoreConfig } from '@/checkout-instore-legacy/utils/configUtils'
import { ROUTES } from '@/checkout-instore-legacy/constants/RoutesConstants'

import CustomerIdentification from './CustomerIdentification/CustomerIdentificationContainer'
import CartCapture from './CartCapture'

const IDENTIFICATION_SLIDE = 0
const CART_SLIDE = 1
class Identification extends React.Component {
  constructor(props) {
    super(props)

    const initialSlide =
      props.location.pathname === ROUTES.CART_CAPTURE
        ? CART_SLIDE
        : IDENTIFICATION_SLIDE
    this.state = {
      showFullSummary: false,
      loading: false,
      slideIndex: initialSlide,
      transferEnabled: getInstoreConfig().transferEnabled,
    }
  }

  handleToggleSummary = () => {
    this.setState((prevState) => ({
      showFullSummary: !prevState.showFullSummary,
    }))
  }

  handleLoading = (loading) => {
    this.setState({
      loading: loading,
    })
  }

  componentDidUpdate(prevProps, prevState) {
    const currentCartCapture =
      this.props.location.pathname === ROUTES.CART_CAPTURE
    const transferEnabled = this.state.transferEnabled
    const transferWasEnabled = prevState.transferEnabled

    if (transferEnabled !== transferWasEnabled) {
      this.swiper.update()
    }

    if (
      prevState.slideIndex === this.state.slideIndex &&
      this.state.slideIndex === IDENTIFICATION_SLIDE &&
      currentCartCapture
    ) {
      this.swiper && this.swiper.slideTo(CART_SLIDE)
    } else if (
      prevState.slideIndex === this.state.slideIndex &&
      this.state.slideIndex === CART_SLIDE &&
      !currentCartCapture
    ) {
      this.swiper && this.swiper.slideTo(IDENTIFICATION_SLIDE)
    } else {
      this.swiper && this.swiper.slideTo(this.state.slideIndex)
    }
  }

  componentWillUnmount() {
    CustomEvent.unlistenEvent('config.updated', this.handleConfigUpdated)
  }

  componentDidMount() {
    this.props.clearSearch()
    CustomEvent.listenEvent('config.updated', this.handleConfigUpdated)
  }

  handleConfigUpdated = () => {
    const transferEnabled = getInstoreConfig().transferEnabled
    const transferWasEnabled = this.state.transferEnabled
    // forces update when instore config is loaded,
    // in order to build the swiper component
    if (transferEnabled !== transferWasEnabled) {
      this.setState({
        transferEnabled,
      })
    }
  }

  render() {
    const { showFullSummary, loading, slideIndex, transferEnabled } = this.state
    const { router, order } = this.props
    const orderForm = order.orderForm
    const clientProfileData = orderForm ? orderForm.clientProfileData : null

    const swiperParams = {
      initialSlide: slideIndex,
      threshold: 15,
      on: {
        slideChange: () => {
          if (!this.swiper) return
          this.setState({
            slideIndex: this.swiper.activeIndex,
          })
        },
      },
      noSwiping: true,
      shouldSwiperUpdate: true,
    }

    return (
      <div className="flex flex-auto flex-column flex-row-l relative vh-100">
        <div
          className={classNames(
            'flex animate-height bg-light-silver overflow-auto flex-auto',
            { 'swiper-no-pagination': !transferEnabled },
            showFullSummary ? 'flex-shrink' : 'flex-grow'
          )}
        >
          <Swiper
            ref={(el) => {
              this.swiper = el && el.swiper
            }}
            containerClass="flex flex-auto overflow-hidden"
            {...swiperParams}
          >
            <div className="ph5">
              <CustomerIdentification
                clearCustomer={this.props.clearCustomer}
                location={this.props.location}
                router={this.props.router}
                route={this.props.route}
                onLoading={this.handleLoading}
                key="customer-identification"
                visible={slideIndex === IDENTIFICATION_SLIDE}
              />
            </div>
            {transferEnabled && (
              <div className="ph5">
                <CartCapture
                  router={router}
                  visible={slideIndex === CART_SLIDE}
                />
              </div>
            )}
          </Swiper>
        </div>

        {/* TODO: use React Portals for the Loader */}
        <Loader loading={loading} />

        {clientProfileData &&
          (clientProfileData.email != null ||
            clientProfileData.document != null) && (
            <Footer
              showFullSummary={this.state.showFullSummary}
              onHandleToggleSummary={this.handleToggleSummary}
            />
          )}
      </div>
    )
  }
}

Identification.propTypes = {
  router: PropTypes.any,
  route: PropTypes.object,
  location: PropTypes.object,
  clearCustomer: PropTypes.func.isRequired,
  clearSearch: PropTypes.func.isRequired,
  order: PropTypes.object.isRequired,
}

export default withRouter(Identification)
